import styled, { useTheme } from 'styled-components';
import Modal, { FullHeightModalContent } from '../../../components/Modal';
import { ParagraphLargeText } from '../../../components/Texts';
import Steps from '../../../components/Steps';
import { useState } from 'react';
import Customize from './components/Customize';
import Confirmation from './components/Confirmation';
import AmountSelector from './components/AmountSelector';
import { useGiftForm } from '../../../components/GiftFormContext';
import { usePrivy } from '@privy-io/react-auth';
import useCustomLogin from '../../../hooks/useCustomLogin';

const TitleAndStepsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const STEP_MAPPER = {
  0: Customize,
  1: AmountSelector,
  2: Confirmation,
};

const GiftFlowModal = ({ onClose, initialStep = 0 }) => {
  const { sendingStatus } = useGiftForm();
  const theme = useTheme();
  const { user } = usePrivy();
  const { login } = useCustomLogin();
  const [currentStep, setCurrentStep] = useState(
    sendingStatus !== 'idle' ? 2 : initialStep,
  );

  const handleStepChange = (step) => {
    setCurrentStep(step);
  };

  const onBack = () => {
    setCurrentStep(currentStep - 1);
  };

  const Component = STEP_MAPPER[currentStep];

  const shouldShowBackButton =
    currentStep === 1 || (currentStep === 2 && sendingStatus === 'idle');

  return (
    <Modal onClose={onClose} onBack={shouldShowBackButton ? onBack : undefined}>
      <FullHeightModalContent>
        <TitleAndStepsContainer>
          <ParagraphLargeText
            style={{ textAlign: 'center', color: theme.text.title }}
          >
            Create Gift
          </ParagraphLargeText>
          <Steps steps={3} currentStep={currentStep} />
        </TitleAndStepsContainer>
        <Component
          onContinue={() => {
            if (currentStep === 0) {
              if (!user) {
                login();
                return;
              }
              handleStepChange(1);
            } else if (currentStep === 1) {
              handleStepChange(2);
            }
          }}
        />
      </FullHeightModalContent>
    </Modal>
  );
};

export default GiftFlowModal;
